import { ArrowRight, Quote, Sparkles } from "lucide-react";
import { Button, Highlight, Section } from "@/components/ui";
import { SUBJECT_PICKER } from "@/data/home";

/** Closing statement between "Seasons" and "Experiences". Its CTA scrolls to the experiences below. */
export function QuoteSection() {
  const quote = SUBJECT_PICKER.quote;
  return (
    <Section labelledBy="home-quote-text" testId="home-quote-section" spacing="compact">
      <figure
        className="rounded-5xl border border-brand-200 bg-brand-50 p-6 shadow-soft sm:p-10 lg:grid lg:grid-cols-12 lg:items-center lg:gap-10 lg:p-14"
        data-testid="home-quote"
      >
        <div className="lg:col-span-7">
          <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-brand-200 bg-white px-3 py-1 text-xs font-bold uppercase tracking-wide text-brand-700 sm:text-sm">
            <Sparkles className="h-3.5 w-3.5 text-brand-500" aria-hidden="true" />
            Real talk
          </span>
          <span
            className="mb-5 flex h-12 w-12 items-center justify-center rounded-2xl bg-white text-brand-500 shadow-soft sm:h-14 sm:w-14"
            aria-hidden="true"
          >
            <Quote className="h-6 w-6 sm:h-7 sm:w-7" />
          </span>
          <blockquote id="home-quote-text">
            <p className="max-w-[22ch] font-heading text-xl font-bold leading-snug text-brand-600 sm:text-3xl">{quote.lead}</p>
            <p className="mt-2 font-heading text-4xl font-bold leading-[1.02] sm:text-6xl lg:max-w-[14ch]">
              {quote.main} <Highlight>{quote.accent}</Highlight>
            </p>
          </blockquote>
        </div>

        <figcaption className="mt-8 flex flex-col gap-4 lg:col-span-5 lg:mt-0 lg:border-l lg:border-brand-200 lg:pl-10">
          <p className="text-base font-semibold sm:text-lg">{quote.hint}</p>
          <ul className="flex flex-wrap gap-2">
            {quote.chips.map((chip) => (
              <li
                key={chip}
                className="rounded-full border border-brand-200 bg-white px-3 py-1 text-xs font-bold text-ink sm:text-sm"
              >
                {chip}
              </li>
            ))}
          </ul>
          <div>
            <Button href={quote.cta.to} size="lg" className="w-full sm:w-auto" data-testid="home-quote-cta">
              {quote.cta.label}
              <ArrowRight className="h-5 w-5" aria-hidden="true" />
            </Button>
          </div>
        </figcaption>
      </figure>
    </Section>
  );
}
